<template>
	<div class="prolist_cn">
		<div class="pl_pc" v-if="!isPhone">
			<div class="pro_banner">
				<img :src="banner" />
			</div>
			<div class="sort_con">
				<div class="sort_list bgimg1 flex3">
					<div data-aos="fade-up" class="sort_item" v-for="(item, index) in goodsList" :key="index">
						<div class="sot_d1">
							<img :src="staticImg + item.image" />
						</div>
						<div class="sot_d2">
							<p class="sot_d2_p1">{{ item.name }}</p>
							<p class="sot_d2_p2">{{ item.description }}</p>
							<p class="sot_d2_p3" @click="toProductDetail(item.id)">
								去看看>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pl_phone" v-if="isPhone">
			<Header2 :meauShow="false" :searchShow="false" pageTitle="产品系列"></Header2>
			<div class="pro_banner">
				<img :src="banner" />
			</div>
			<div class="pp_text">
				<p class="pp_p1">剑南春系列</p>
				<p class="pp_p2">
					剑南春酒甄选优质粮谷为原料，采用传承千年，不断丰富与完善的古老秘法为酿造技艺，经古老窖池发酵，经年贮存，精心勾调而成。
				</p>
			</div>
			<div class="sort_con">
				<div class="sort_list bgimg1">
					<div class="sort_item" v-for="(item, index) in goodsList" :key="index" @click="toProductDetail(item.id)">
						<div class="sot_d1">
							<img :src="staticImg + item.image" />
						</div>
						<div class="sot_d2">
							<p class="sot_d2_p1">{{ item.name }}</p>
							<p class="sot_d2_p2">{{ item.description }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			goodsList: [],
			banner: "",
			staticImg: this.$staticImg + "/",
			isPhone: this.$isMobile,
			xlid: "", //系列id
			ftype: "",
		};
	},
	watch: {
		$route(to, from) {
			this.xlid = this.$route.query.xlid;
			this.ftype = this.$route.query.type;
			this.productList();
		},
	},
	created() {
		this.xlid = this.$route.query.xlid;
		this.ftype = this.$route.query.type;
		this.productList();
	},
	methods: {
		// 系列下的产品列表
		async productList() {
			var data1 = {
				product_id: this.ftype == 2 ? this.xlid : "",
				cate_id: this.ftype == 1 ? this.xlid : "",
			};
			const res = await this.$api.productList(data1);
			if (res.code == 1) {
				this.goodsList = res.data.product;
				this.banner = this.staticImg + res.data.banner;
			}
		},
		toProductDetail(id) {
			this.$router.push("/productDetail?gid=" + id + '&banner=' + this.banner);
		},
	},
}
</script>

<style lang="scss">
.prolist_cn {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.pl_pc {
		margin-top: 76px;
		.pro_banner {
			img {
				width: 100%;
			}
		}
		.sort_con {
			width: 100%;
			padding: 50px 0 100px;
			min-height: 300px;
			background-image: url("../../images/bgimg3.png");
			.sort_list {
				max-width: 1200px;
				min-width: 950px;
				margin: 0 auto;
				flex-wrap: wrap;
				.sort_item {
					box-sizing: border-box;
					width: 33.3%;
					padding: 0 20px;
					margin-bottom: 36px;
					.sot_d1 {
						height: 310px;
						line-height: 310px;
						background-color: #ece5de;
						overflow: hidden;
						display: flex;
						align-items: center;
						justify-content: center;
						img {
							max-width: 85%;
							max-height: 85%;
							transition: transform 0.5s ease;
							&:hover {
								transform: scale(1.1);
							}
						}
					}
					.sot_d2 {
						background-color: #fff;
						padding: 28px 10px 20px;
						.sot_d2_p1 {
							text-align: center;
							color: #000;
							font-size: 24px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							margin-bottom: 10px;
						}
						.sot_d2_p2 {
							text-align: center;
							color: #666;
							font-size: 16px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							margin-bottom: 22px;
						}
						.sot_d2_p3 {
							width: 101px;
							height: 30px;
							line-height: 28px;
							text-align: center;
							border-radius: 29px;
							color: #666;
							font-size: 14px;
							border: 1px solid #ccc;
							margin: 0 auto;
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	.pl_phone {
		padding: 1.23rem 0 2.4rem 0;
		background-image: url("../../images/bgimg3.png");
		.pro_banner {
			img {
				width: 100%;
				height: auto;
				display: block;
			}
		}
		.pp_text {
			background-color: #fff;
			padding: 0.45rem 0.64rem;
			.pp_p1 {
				color: #333;
				font-size: 18px;
				text-align: center;
				margin-bottom: 0.32rem;
			}
			.pp_p2 {
				text-align: center;
				color: #333;
				font-size: 17px;
				line-height: 1.7;
			}
		}
		.sort_con {
			padding: 0.51rem 0.64rem;
			.sort_list {
				.sort_item {
					margin-bottom: 0.4rem;
					.sot_d1 {
						padding: 0.5rem;
						background-color: #f5f5f5;
						img {
							width: 100%;
						}
					}
					.sot_d2 {
						background-color: #fff;
						text-align: center;
						padding: 0.45rem 0.27rem;
						.sot_d2_p1 {
							color: #000;
							font-size: 17px;
							margin-bottom: 0.15rem;
						}
						.sot_d2_p2 {
							color: #666;
							font-size: 15px;
						}
					}
				}
			}
		}
	}
}
</style>